function getButtons() {
  return document.querySelectorAll('button');
}

function getBoard() {
  return document.querySelector('.board');
}

/*
 * Shuffles the elements of an array in place 
 */
function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}

/*
 * Returns a random item from the array
 */
function sample(arr) {
  const answer = arr[Math.floor(Math.random() * arr.length)];
  return answer;
}

/*
 * Removes the _item_ from the DOM after a 500ms transition
 */
function destoryItem(item, adjust = true) {
  item.classList.add("transition--500");
  item.classList.add("poof");
  setTimeout(() => {
    if (adjust) {
      deleteAndAdjustPositions(item);
    }
    else item.remove();
  }, 500)
}


function deleteAndAdjustPositions(item) {
  //Record the first positions
  let buttons = Array.from(document.querySelectorAll(".board button"));
  const transitionValue = buttons[0].style.transition;
  document.querySelectorAll(".board button").forEach((button) => { button.style.transition = "" });
  // buttons.forEach((button) => button.style.transition = "none");
  const firstPositions = buttons.reduce((acc, button) => {
    acc[button.id] = button.getBoundingClientRect();
    return acc;
  }, {});

  item.remove();

  // Check the new positions
  buttons = Array.from(document.querySelectorAll(".board button"));
  const lastPositions = buttons.reduce((acc, button) => {
    acc[button.id] = button.getBoundingClientRect();
    return acc;
  }, {});

  buttons.forEach((button) => {
    const deltaX = firstPositions[button.id].left - lastPositions[button.id].left;
    const deltaY = firstPositions[button.id].top - lastPositions[button.id].top;
    const str = button.style.transform;
    const matches = str.match(/[+-]?\d+(\.\d+)?/g);
    if (matches) {
      const transformValues = {
        x: parseFloat(matches[0]) + deltaX,
        y: isNaN(parseFloat(matches[1])) ? 0 : parseFloat(matches[1]) + deltaY,
      }
      button.style.transform = `translate(${transformValues.x}px, ${transformValues.y}px)`;
    }
  });

  buttons.forEach((button) => button.style.transition = transitionValue);
}

/* 
 * Determines if the user agent is a mobile device or not
 */
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
}


export { getBoard, getButtons, sample, shuffle, destoryItem, isMobileDevice };
